import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import ImageGallery from 'react-image-gallery'
import {Link} from 'react-router-dom'
import Pactilacel from "../Assets/Paclitaxel.jpg";
import Map from "../Assets/Map.jpg";
import {HashLink} from 'react-router-hash-link';

const linodeObjectUrl  = 'https://cdn.mannheim-urology.com/optilume/Optilume_BHP'
const thumbnailsObjectUrl = `${linodeObjectUrl}/thumbnails`

const images = [
    {
        original: `${linodeObjectUrl}/optilume_T.jpg`,
        thumbnail: `${linodeObjectUrl}/optilume_T.jpg`,
    },
    {
        original: `${linodeObjectUrl}/optilume_T2.png`,
        thumbnail: `${linodeObjectUrl}/optilume_T2.png`,
    },
    {
        original: `${linodeObjectUrl}/optilume_T3.png`,
        thumbnail: `${linodeObjectUrl}/optilume_T3.png`,
    }
]



const linodeObjectUrl2  = 'https://cdn.mannheim-urology.com/optilume/single_bulbar_strictures'

const images_linodeObjectUrl2 = [
    {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0001.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0001.jpg`,
    },
    {
        original: `${linodeObjectUrl2}/single_bulbar_strictures_0002.jpg`,
        thumbnail: `${linodeObjectUrl2}/thumb-single_bulbar_strictures_0002.jpg`,
    } 
]

 


colorLinks("#11ABB0");

function colorLinks(hex)
{
    var links = document.getElementsByTagName("a");
    for(var i=0;i<links.length;i++)
    {
        if(links[i].href)
        {
            links[i].style.color = hex;  
        }
    }  
}



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '75%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/Optilume_video2.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 100 }} 
      />
    </div>
  );
};

 
const Optilume_BPH = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                        <h2>Обещаваща нова технология дава надежда на милиони мъже в цяла Европа, страдащи от стриктурa
                            на уретрата (стесняванe на пикочния канал)</h2> 
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
                    <h3> What is the Optilume® BPH Catheter System, and how is it used? </h3>
                    <p> 
                    
                    <p>Optilume is a new, approved minimally invasive treatment for benign prostatic hyperplasia (BPH). Typically administered as an outpatient procedure, Optilume® BPH is a drug-coated balloon that is inserted into the urethra via a telescopic camera, to the prostate. Once in the prostate, the balloon expands creating an opening, and releases the safe and proven drug, Paclitaxel, into the open prostate. When the drug coating is fully released, the balloon is deflated and removed. The drug prevents re-fusion of the lobes during healing, keeping the prostate open, restoring the flow of urine and relieving you of your bothersome symptoms. Clinical studies show Optilume® BPH is safe, effective, and with:</p>

 
<ul>
  <li> - Immediate and durable symptom relief</li>
  <li> - Minimal catheter time</li>
  <li> - No impact on sexual function</li>
  <li> - Quick recovery</li>
  <li> - Highest clinically reported flow rates of any minimal invasive therapy</li>
  <li> - In-office/outpatient procedure</li>
</ul>

<p>No cutting. No heating. No burning. No lasering. No steaming. No implantation! Choose the Optilume® BPH Catheter System for immediate, lasting results. </p>

<ImageGallery items={images}/>

<p>After the Optilume® BPH procedure, you will notice an immediate improvement in both urinary symptoms and quality of life, including improved urinary flow and the ability to happily relieve your bladder. Clinical studies show significant and durable improvements, allowing you to reclaim control of your urinary system.</p>



<p>Discover the difference Optilume® BPH can make in restoring your quality of life!</p>

 
                          </p>

 
          
                        <br/>
                    </div>
                     
                </section>



            )
    }
}

export default Optilume_BPH



// WEBPACK FOOTER //
// ./src/Components/Optilume_BPH.js